angular.module('impactx.toolbar').service('ToolbarService', [
    '$rootScope',
    '$securityManager',
    'TranslationService',
    'BackService',
    '$timeout',
    '$route',
    ToolbarService
]);

function ToolbarService($rootScope, $securityManager, TranslationService, BackService, $timeout, $route) {
    
    var self = this;
    var buttonDefinition = [];
    var isBackButtonHidden = false;
    var toolbarHidden = {
        value: false
    };
    var refreshButtonFunction = undefined;
    var backButtonFunction = BackService.back;

    var changeConditionWatcher;
    var buttonConditionWatchers = [];
    var dialogFilterFlag = undefined;
    self.buttons = {
        inlineButtons: [],
        overflowButtons: []
    };

    self.showListFilterToggle = {
        value: false
    };

    self.showSearchFilterToggle = {
        value: false
    };

    self.showLeftFilterToggle = {
        value: false
    };

    self.showDialogFilterToggle = {
        value: false
    };

    self.showPersistentListFilters = {
        value: false
    };

    self.scrollMenu = {
        entries: []
    };

    // ToDo: use closures to avoid passing function parameters
    // ToDo: resolve translations in the buttons definitions instead of passing them (just for lists)
    self.data = {
        translations: undefined,
        optionalDataFields: undefined
    };

    $rootScope.$on('$routeChangeStart', function () {
        buttonDefinition = [];
        self.buttons.inlineButtons = [];
        self.buttons.overflowButtons = [];
        self.data.optionalDataFields = undefined;
        self.data.translations = undefined;
        self.showListFilterToggle.value = false;
        self.showSearchFilterToggle.value = false;
        self.showPersistentListFilters.value = false;
        self.scrollMenu.entries = [];
        refreshButtonFunction = undefined;
        isBackButtonHidden = false;
        backButtonFunction = undefined;
        toolbarHidden.value = false;
        if (changeConditionWatcher)
        {
            changeConditionWatcher();
        }
        for (var i = 0; i < buttonConditionWatchers.length; i++)
        {
            buttonConditionWatchers[i]();
        }
    });

    function setButtons(buttons, buttonTranslations, optionalData, options, route) {
        if ($route.current && $route.current.$$route && $route.current.$$route.originalPath &&
            $route.current.$$route.originalPath === "/afterlogininput" && (!route || route !== "afterlogininput")) {
            return;
        }
        buttonDefinition = buttons;
        self.data.translations = buttonTranslations;
        self.data.optionalDataFields = optionalData;

        var isBackButtonHiddenNow = isBackButtonHidden;
        var refeshButtonVisible = true;
        var backButtonIndex = 0;

        // Angular-Erweiterung
        if(options && typeof options === 'object') {
            if(typeof options.isBackButtonHidden === 'boolean') {
                isBackButtonHiddenNow = options.isBackButtonHidden;
            }
            if(typeof options.refeshButtonVisible === 'boolean') {
                refeshButtonVisible = options.refeshButtonVisible;
            }
            if (typeof options.backButtonIndex === 'number') {
                backButtonIndex = options.backButtonIndex;
            }
        }

        if (!isBackButtonHiddenNow) {
            addBackButton(backButtonIndex);
        }
        if (refeshButtonVisible && refreshButtonFunction) {
            addRefreshButton();
        }

        setLabels(buttonDefinition);

        // Angular-Erweiterung
        if(ixUpgrade && ixUpgrade.extendToolbarItems) {
            ixUpgrade.extendToolbarItems(buttonDefinition);
        }
        
        buttonConditionWatchers = [];
        var i = 0;
        var noChangedCondition = false;
        while(i < buttons.length) {
            (function(button) {
                buttonConditionWatchers.push($rootScope.$watch(function() {
                    return button.condition ? button.condition(self.data.optionalDataFields) : true;
                }, function(newValue, oldValue) {
                    if(newValue != oldValue) {
                        noChangedCondition = false;
                    }
                }));
            })(buttons[i]);
            i++;
        }

        changeConditionWatcher = $rootScope.$watch(function() {
            if(noChangedCondition) return;
            noChangedCondition = true;
            $rootScope.$$postDigest(function() {
                recalcButtons();
            });
        });
    }

    function setScrollMenu(scrollList) {
        self.scrollMenu.entries = scrollList;
    }

    function showListFilterToggle() {
        self.showListFilterToggle.value = true;
    }

    function hideListFilterToggle() {
        self.showListFilterToggle.value = false;
    }

    function showSearchFilterToggle() {
        self.showSearchFilterToggle.value = true;
    }

    function hideSearchFilterToggle() {
        self.showSearchFilterToggle.value = false;
    }

    function showLeftFilterToggle() {
        self.showLeftFilterToggle.value = true;
    }

    function hideLeftFilterToggle() {
        self.showLeftFilterToggle.value = false;
    }

    function showDialogFilterToggle(dialogFilterFlagToUse) {
        self.showDialogFilterToggle.value = true;
        dialogFilterFlag = dialogFilterFlagToUse;
    }

    function hideDialogFilterToggle() {
        self.showDialogFilterToggle.value = false;
        dialogFilterFlag = undefined;
    }

    function toggleDialogSidebar() {
        dialogFilterFlag.value = !dialogFilterFlag.value;
    }

    function showPersistentListFilter() {
        self.showPersistentListFilters.value = true;
    }

    function restoreRefreshButtonFunction(oldFn) {
        refreshButtonFunction = oldFn;
    }

    /**
     * Registriert den Callback für Refresh-Button und
     * liefert eine Subscription.
     * 
     * Die Funktion showRefreshButton erzeugt ein Speicherleck.
     * 
     * @param {*} func 
     * @returns ein Subscription-Object mit unsubscribe-Funktion um 
     * die Callback-Funktion wieder zu entbinden.
     */
    function attachRefreshButtonFunction(func) {
        if (func && typeof func === 'function') {
            var restorFn = (function(fn) {
                return function() {
                    restoreRefreshButtonFunction(fn);
                };
            }(refreshButtonFunction));

            refreshButtonFunction = func;

            return {
                unsubscribe: function(){
                    restorFn();
                }
            };    
        }
        return {
            unsubscribe: function(){}
        };
    }
    // Die Funktion showRefreshButton erzeugt ein Speicherleck.
    // Begründung:
    // Wenn die Funktion aufgerufen wird, so wird der Parameter (hier) intern
    // im Service gespeichert, also eine Referenz auf die Funktion.
    // Die referenzierte Funktion nutzt intern höchstwarscheinlich eine
    // Referenz auf eine 'Controller-Instanz' der Komponente die beim Klicken 
    // auf den Refresh-Button 'sich auffrischen' soll.
    // D.h. solange die Referenz auf die Funktion hier im Service nicht 
    // mit neuem Wert überschrieben wird darf auch die JS-Runtime die
    // 'Controller-Instanz' nicht mit garbage collector aufräumen.
    

    function showRefreshButton(func) {
        if (func && typeof func === 'function') {
            refreshButtonFunction = func;
        }
    }

    function recalcInternal(totalWidth) {
        var currUsedWidth = 0;
        var i = 0;
        var currentButton;
        self.buttons.hasSpacer = false;

        while (i < buttonDefinition.length) {
            currentButton = buttonDefinition[i];

            if ((!currentButton.condition || currentButton.condition(self.data.optionalDataFields)) &&
                (!currentButton.process || $securityManager.isProcessAllowed(currentButton.process))) {
                //104 is the min width of a button. 12 is the total padding, 16 is the total margin
                if (currentButton.type === 'icon') {
                    currUsedWidth += 64;
                }
                else {
                    currUsedWidth += Math.max(104, getWidthOfText(currentButton.label, '14px', '600', '.01em') + 12 + 16);
                }
                if (currUsedWidth >= totalWidth) {
                    break;
                }
                self.buttons.inlineButtons.push(currentButton);
                if(currentButton.type === 'spacer') {
                    self.buttons.hasSpacer = true;
                }
            }
            i++;
        }

        while (i < buttonDefinition.length) {
            currentButton = buttonDefinition[i];

            if ((!currentButton.condition || currentButton.condition(self.data.optionalDataFields)) &&
                (!currentButton.process || $securityManager.isProcessAllowed(currentButton.process))) {
                self.buttons.overflowButtons.push(currentButton);
            }
            i++;
        }
    }

    function recalcButtons(force) {
        // no need to recalc if no buttons are defined
        if (force || (buttonDefinition && buttonDefinition.length > 0)) {
            self.buttons.inlineButtons = [];
            self.buttons.overflowButtons = [];
            var elementWidth = angular.element("ix-toolbar-tools").width();
            // since IE sometimes seems to be too slow: wait for <ix-toolbar-tools> to have a width > 0
            if (elementWidth > 0) {
                // -52 for the dropdown button, -52 for the scroll menu button
                recalcInternal(elementWidth - 52 - 52);
            }
            else {
                $timeout(recalcButtons);
            }
        }
    }

    function getWidthOfText(txt, fontsize, fontweight, letterspacing) {
        var e = document.createElement('span');
        e.style.fontSize = fontsize;
        e.style.fontWeight = fontweight;
        e.style.letterSpacing = letterspacing;
        if (txt) {
            e.innerHTML = txt.toUpperCase();
        }
        document.body.appendChild(e);
        var w = e.offsetWidth;
        document.body.removeChild(e);
        return w;
    }

    function setLabels(buttons) {
        angular.forEach(buttons, function (button) {
            var label;
            //For Angular: for development purpose
            if(button.rawLabel) {
                button.label = button.rawLabel;
                return;
            }
            if (impactX.isDefined(self, 'data.translations')) {
                label = self.data.translations[button.label];
            }
            else {
                label = button.label;
            }
            button.label = label;
        })
    }

    function addBackButton(index) {
        if (buttonDefinition) {
            var backButton = {
                labelFunction: getBackButtonLabel,
                type: 'dialogaction',
                action: navigateBack
            };

            var tmp = buttonDefinition.splice(0, index, backButton);
            buttonDefinition = tmp.concat(buttonDefinition);
        }
    }

    function addRefreshButton() {
        if (buttonDefinition) {
            var refreshButton = {
                icon: 'mdi-refresh',
                type: 'icon',
                action: refreshButtonFunction
            };

            buttonDefinition.unshift(refreshButton);
        }
    }

    function getBackButtonLabel() {
        return TranslationService.get('back');
    }

    function hideBackButton() {
        isBackButtonHidden = true;
    }

    function navigateBack() {
        if (backButtonFunction) {
            backButtonFunction();
        }
        BackService.back();
    }

    function backButtonCallback(callback) {
        backButtonFunction = callback;
    }

    function hideToolbar() {
        toolbarHidden.value = true;
    }

    return {
        buttons: self.buttons,
        data: self.data,
        scrollMenu: self.scrollMenu,
        isToolbarHidden: toolbarHidden,
        showListFilter: self.showListFilterToggle,
        showLeftFilter: self.showLeftFilterToggle,
        showSearchFilter: self.showSearchFilterToggle,
        showDialogFilter: self.showDialogFilterToggle,
        showPersistentListFilters: self.showPersistentListFilters,
        setButtons: setButtons,
        recalcButtons: recalcButtons,
        showListFilterToggle: showListFilterToggle,
        hideListFilterToggle: hideListFilterToggle,
        showSearchFilterToggle: showSearchFilterToggle,
        hideSearchFilterToggle: hideSearchFilterToggle,
        showDialogFilterToggle: showDialogFilterToggle,
        hideDialogFilterToggle: hideDialogFilterToggle,
        showLeftFilterToggle: showLeftFilterToggle,
        hideLeftFilterToggle: hideLeftFilterToggle,
        toggleDialogSidebar: toggleDialogSidebar,
        showPersistentListFilter : showPersistentListFilter,
        hideBackButton: hideBackButton,
        backButtonCallback: backButtonCallback,
        hideToolbar: hideToolbar,
        showRefreshButton: showRefreshButton,
        setScrollMenu: setScrollMenu,
        // Ab Angular-Upgrade
        attachRefreshButtonFunction: attachRefreshButtonFunction
    };
}